import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getPettyCashDailyBalances = async () => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/petty-cash-daily-balances/`);
        return await response.data;
    } catch (error) {
        console.log("getPettyCashDailyBalances - error", error)
        return handleApiError(error)
    }
}

export const getPettyCashDailyBalanceById = async (pettyCashDailyBalanceId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/petty-cash-daily-balances/${pettyCashDailyBalanceId}`);
        return await response.data;
    } catch (error) {
        console.log("getPettyCashDailyBalanceById - error", error)
        return handleApiError(error)
    }
}

export const insertPettyCashDailyBalances = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/petty-cash-daily-balances/insert`, data);
        return await response.data;
    } catch (error) {
        console.log("insertPettyCashDailyBalances - error", error)
        return handleApiError(error)
    }
}


export const getPettyCashDailyBalanceByPettyCashAccountId = async (pettyCashAccount) => {

    try {
        const response = await axios.get(`${REACT_APP_API_URL}/petty-cash-daily-balances/get/${pettyCashAccount}`);
        return response.data.data;
    } catch (error) {
        console.log("getPettyCashDailyBalanceByPettyCashAccountId - error", error)
        return handleApiError(error)
    }
}

export const getPettyCashDailyOpeningAndClosingBalances = async (pettyCashAccount, data) => {

    try {
        const response = await axios.post(`${REACT_APP_API_URL}/petty-cash-daily-balances/opening-closing/${pettyCashAccount}`, data);
        return response.data.data;
    } catch (error) {
        console.log("getPettyCashDailyOpeningAndClosingBalances - error", error)
        return handleApiError(error)
    }
}
